// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u-revert {
  transform: scale(-1, 1);
}

.u-relative {
  position: relative;
}

.u-absolute {
  position: absolute;
}

.u-pointer {
  cursor: pointer;
}

.u-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.u-text-red {
  color: var(--m-danger);
}

.u-text-center {
  text-align: center;
  background-color: tomato;
}`, "",{"version":3,"sources":["webpack://./src/styles/utilities.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,wBAAA;AACJ","sourcesContent":[".u-revert {\n    transform: scale(-1, 1);\n}\n\n.u-relative {\n    position: relative;\n}\n\n.u-absolute {\n    position: absolute;\n}\n\n.u-pointer {\n    cursor: pointer;\n}\n\n.u-ellipsis {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.u-text-red {\n    color: var(--m-danger);\n}\n\n.u-text-center {\n    text-align: center;\n    background-color: tomato;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
